var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute inset-0 overflow-hidden flex flex-col-reverse items-center"},[_c('div',{staticClass:"absolute -left-px -right-px bottom-0 flex flex-col-reverse pb-10",attrs:{"id":"text"}},[_c('title-description-block')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }